import getLogger from "../../logger/index";
import { config } from "api/config";
const log = getLogger("ASK_QUESTION");
import { post } from "util/apiRequest";
import { getDynamicRoute } from "util/createProfileIdPath";

export const ASK_A_QUESTION_REQUEST = "ASK_A_QUESTION_REQUEST";
export const ASK_A_QUESTION_SUCCESS = "ASK_A_QUESTION_SUCCESS";
export const ASK_A_QUESTION_FAILURE = "ASK_A_QUESTION_FAILURE";
export const ASK_A_QUESTION_CLEAR = "ASK_A_QUESTION_CLEAR";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const CALL_SUCCESS = "Call_Success";
export const ERROR = "Error";
export const CLEAR = "Clear";

export function askAQuestionRequest() {
  return {
    type: ASK_A_QUESTION_REQUEST,
    status: REQUESTING,
  };
}
export function askAQuestionSuccess(postResponse, leadType = null) {
  leadType ? null : sessionStorage.setItem("lead_generated", true);
  return {
    type: ASK_A_QUESTION_SUCCESS,
    status: leadType ? CALL_SUCCESS : SUCCESS,
    postResponse,
  };
}
export function askAQuestionFailure(error) {
  sessionStorage.setItem("lead_generated", false);
  return {
    type: ASK_A_QUESTION_FAILURE,
    status: ERROR,
    error,
  };
}
export function askAQuestionClear() {
  return {
    type: ASK_A_QUESTION_CLEAR,
    status: CLEAR,
    postResponse: null,
  };
}

export function askAQuestion(requestInformation) {
  return async (dispatch) => {
    dispatch(askAQuestionRequest());
    const dynamicRouteName = getDynamicRoute();
    try {
      // Facing cors issue
      log.error("Normal Lead Submission : " + requestInformation.profileId);
      if (
        !requestInformation.profileId &&
        requestInformation.url &&
        requestInformation.url.indexOf(`${dynamicRouteName}/`) !== -1
      ) {
        requestInformation.profileId = requestInformation.url.split(`${dynamicRouteName}/`)[1];
      }
      const result = await post(
        `${config.GATEWAY_URL}/${dynamicRouteName}/api/v3/ask_a_question`,
        requestInformation,
        5000,
      );
      const resultJson = result;
      log.error("Normal Lead Submission Response: " + JSON.stringify(resultJson));
      // Need to check error condition
      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      if (requestInformation.lead_type === "call") {
        return dispatch(askAQuestionSuccess(resultJson, requestInformation.lead_type));
      } else {
        return dispatch(askAQuestionSuccess(resultJson));
      }
    } catch (e) {
      log.error("Normal Lead Submission Failed : " + JSON.stringify(requestInformation), e);
      log.error(
        "Error while submit ASK_A_QUESTION_REQUEST data  - Advertiser_id / Email: " +
          requestInformation?.advertiser_id +
          " / " +
          requestInformation?.email,
        e,
      );
      dispatch(askAQuestionFailure(e.message));
    }
  };
}
